import { render, staticRenderFns } from "./releaseTopic.vue?vue&type=template&id=c5d736fa"
import script from "./releaseTopic.vue?vue&type=script&lang=js"
export * from "./releaseTopic.vue?vue&type=script&lang=js"
import style0 from "./releaseTopic.vue?vue&type=style&index=0&id=c5d736fa&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports